import { render } from "./HeaderComp.vue?vue&type=template&id=77eccd82&ts=true"
import script from "./HeaderComp.vue?vue&type=script&lang=ts"
export * from "./HeaderComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__